import { render } from "./CustomerBalance.vue?vue&type=template&id=30a1d92a&scoped=true"
import script from "./CustomerBalance.vue?vue&type=script&lang=js"
export * from "./CustomerBalance.vue?vue&type=script&lang=js"

import "./CustomerBalance.vue?vue&type=style&index=0&id=30a1d92a&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a1d92a"]])

export default __exports__